import PropTypes from "prop-types";
import React from "react";

import Default from "./promos/Default";
import DesktopBanner from "./promos/DesktopBanner";
import DonationDialog from "./promos/DonationDialog";
import EndOfArticle from "./promos/EndOfArticle";
import StickyPopup from "./promos/StickyPopup";
import LazyLoad, { LazyWrapper } from "./LazyLoad";
import MobileBanner from "./promos/MobileBanner";
import RepublishPanel from "./RepublishPanel";
import { eventBus, redirectTo } from "../utils";
import { trackDismiss, trackEngagement, trackImpression } from "../promo_tracking";

/**
 * This component renders a promo of the given type. Several promos support lazy
 * rendering.
 */
function Component(props) {
  switch (props.type) {
    case "DesktopBanner":
      return <LazyLoad onView={props.onView}><DesktopBanner {...props} /></LazyLoad>;
    case "DonationDialog":
      return <LazyWrapper onView={props.onView}><DonationDialog {...props} /></LazyWrapper>;
    case "EndOfArticle":
      return <LazyLoad onView={props.onView}><EndOfArticle {...props} /></LazyLoad>;
    case "MobileBanner":
      return <LazyLoad onView={props.onView}><MobileBanner {...props} /></LazyLoad>;
    case "Republish":
      return <LazyWrapper onView={props.onView}><RepublishPanel {...props} /></LazyWrapper>;
    case "StickyPopup":
      return <LazyWrapper onView={props.onView}><StickyPopup {...props} /></LazyWrapper>;
    default:
      return <LazyWrapper onView={props.onView}><Default {...props} /></LazyWrapper>;
  }
}

Component.propTypes = {
  type: PropTypes.string.isRequired,
  onView: PropTypes.func.isRequired,
};

/**
 * The promo component renders a promo.
 */
function Promo({ promo, onClick, onClose, onView }) {
  // Track the click event and trigger any custom events.
  const handleClick = () => {
    trackEngagement(promo);
    onClick(promo);

    if (promo.data.trigger) {
      eventBus.next({ ...promo.data.trigger });
    } else if (promo.data.href) {
      redirectTo(promo.data.href);
    }
  };

  // Track the close event and notify Google Analytics.
  const handleClose = () => {
    onClose(promo);
    trackDismiss(promo);
  };

  // Track the view event and notify Google Analytics.
  const handleView = () => {
    onView(promo);
    trackImpression(promo);
  };

  return (
    <div className="promo">
      <Component
        {...promo.data}
        onClick={handleClick}
        onClose={handleClose}
        onView={handleView}
        type={promo.type}
      />
    </div>
  );
}

Promo.propTypes = {
  promo: PropTypes.shape({
    data: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
};

export default Promo;
